import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getCaptureLocationMap } from "../../api/captures/captureLocation";
import { listCaptures } from "../../api/captures/listCaptures";

interface FilterOptions {
  entityId?: number;
  managementUnitId?: number;
  militaryMap?: string;
  search?: string;
}

export const useManagementUnitCaptures = (
  managementUnitIdStr?: string,
  initialEntityId?: number
) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filtersState, setFiltersState] = useState<FilterOptions>({});

  const setFilters = (newFilters: FilterOptions) => {
    setPage(0);
    setFiltersState(newFilters);
};

  const managementUnitId = Number(managementUnitIdStr);

  const capturesQuery = useQuery({
    queryKey: [
      "managementUnit",
      managementUnitId,
      "captures",
      { page, rowsPerPage, ...filtersState },
    ],
    queryFn: () =>
      listCaptures(
        filtersState.entityId,
        managementUnitId,
        filtersState.search,
        filtersState.militaryMap,
        rowsPerPage,
        page * rowsPerPage
      ),
    enabled: !!managementUnitId,
    placeholderData: keepPreviousData,
  });

  const mapQuery = useQuery({
    queryKey: [
      "managementUnit",
      managementUnitId,
      "map",
      { filtersState, initialEntityId },
    ],
    queryFn: () =>
      getCaptureLocationMap(
        filtersState.entityId ?? initialEntityId,
        managementUnitId,
        undefined,
        filtersState.militaryMap,
        filtersState.search
      ),
    enabled: !!managementUnitId,
    placeholderData: keepPreviousData,
  });

  return {
    page,
    rowsPerPage,
    filters: filtersState,
    setPage,
    setRowsPerPage,
    setFilters,
    capturesQuery,
    mapQuery,
  };
};